import React from 'react'
import PropTypes from "prop-types";

const LINK_STYLE = {
    'padding-left': '8px'
}

const FreshSalesInfoTable = ({dealOwner,calendlyLink}) => {

    return (
        <table className="fresh-sales-info-table">
            <tbody>
            <tr>
                <td className="column">Freshsales Deal Owner</td>
                <td className="column">{ dealOwner }</td>
            </tr>
            {
                calendlyLink && (
                    <tr>
                        <td className="column">Freshsales Calendly Link</td>
                        <td><a target="_blank" href={calendlyLink} style={LINK_STYLE}>View</a></td>
                    </tr>
                )
            }
            </tbody>
        </table>
    )
}

FreshSalesInfoTable.propTypes = {
    dealOwner:PropTypes.string.isRequired
}

export default FreshSalesInfoTable




// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/FreshSalesInfoTable.js